import Dexie from 'dexie';

// 1 year
const MAX_FILE_ENTRY_AGE = 365 * 24 * 60 * 60 * 1000;

const LS_ROOT_KEY = 'mozdesigner-viewer';
const LS_FILES_KEY = 'files';

const db = new Dexie('mozDesignerViewer');
db.version(3).stores({
  files: `++id, lastUsed, [name+size+lastModified]`,
});

const cleanup = () => {
  console.log("Deleting old file entries");
  db.files
    .where("lastUsed").below(Date.now() - MAX_FILE_ENTRY_AGE)
    .delete()
    .then(function(cnt) {
      console.log(`Deleted ${cnt} old file entries`);
    });
};
cleanup();

const lookupFile = file => db.files
        .where({
          name: file.name,
          size: file.size,
          lastModified: file.lastModified
        })
        .first();

const storageService = {
  
  async loadFileMetadata(file) {
    return lookupFile(file)
      .then(e => {
        if (e) {
          e.lastUsed = Date.now();
          db.files.put(e);
          return e.metadata;
        } else {
          return {};
        }
      });
  },
  
  async saveFileMetadata(file, metadata) {
    return lookupFile(file)
      .then(e => {
        if (!e) {
          console.log("Creating new file entry");
          e = {
            name: file.name,
            size: file.size,
            lastModified: file.lastModified,
            metadata: metadata,
          };
        }
        e.metadata = metadata;
        e.lastUsed = Date.now();
        db.files.put(e);
        console.log("File metadata saved");
      })
      .finally(() => cleanup());
  }
  
};

const migrateLocalStorage = () => {
  try {
    var data = JSON.parse(localStorage.getItem(LS_ROOT_KEY));
    if (data && data[LS_FILES_KEY]) {
      console.log("Migrating localStorage data")
      for (let entry of data[LS_FILES_KEY]) {
        console.log(`Saving ${entry.name}`);
        storageService.saveFileMetadata(entry, entry.metadata);
      }
    }
    console.log('Deleting localStorage');
    localStorage.removeItem(LS_ROOT_KEY);
  } catch(e) {
    console.log(`Error migrating localStorage data`);
    console.log(e);
  }
};
migrateLocalStorage();

export default storageService;
